var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg92(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 4.81714C0.666992 4.56401 0.855095 4.35481 1.09915 4.3217L1.16699 4.31714L11.167 4.31714C11.4431 4.31714 11.667 4.541 11.667 4.81714C11.667 5.07027 11.4789 5.27947 11.2348 5.31257L11.167 5.31714L1.16699 5.31714C0.89085 5.31714 0.666992 5.09328 0.666992 4.81714Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.666992 4.81714C0.666992 4.56401 0.855095 4.35481 1.09915 4.3217L1.16699 4.31714L11.167 4.31714C11.4431 4.31714 11.667 4.541 11.667 4.81714C11.667 5.07027 11.4789 5.27947 11.2348 5.31257L11.167 5.31714L1.16699 5.31714C0.89085 5.31714 0.666992 5.09328 0.666992 4.81714Z",
    fill: "white",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.781 1.15514C6.58532 0.960301 6.58463 0.64372 6.77948 0.448038C6.9566 0.270145 7.23434 0.253409 7.4304 0.398224L7.48658 0.446515L11.5199 4.46252C11.6983 4.64017 11.7146 4.91891 11.5686 5.11496L11.5199 5.17111L7.48661 9.18778C7.29094 9.38264 6.97436 9.38198 6.7795 9.18632C6.60236 9.00844 6.5868 8.73063 6.73244 8.53519L6.78097 8.47921L10.4583 4.81663L6.781 1.15514Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.781 1.15514C6.58532 0.960301 6.58463 0.64372 6.77948 0.448038C6.9566 0.270145 7.23434 0.253409 7.4304 0.398224L7.48658 0.446515L11.5199 4.46252C11.6983 4.64017 11.7146 4.91891 11.5686 5.11496L11.5199 5.17111L7.48661 9.18778C7.29094 9.38264 6.97436 9.38198 6.7795 9.18632C6.60236 9.00844 6.5868 8.73063 6.73244 8.53519L6.78097 8.47921L10.4583 4.81663L6.781 1.15514Z",
    fill: "white",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg92);
export default __webpack_public_path__ + "static/media/svg92.5239766fcd913a901cf0f0a2cb09c386.svg";
export { ForwardRef as ReactComponent };